import { ShieldCheck, Sparkles, Layers, HeartHandshake } from "lucide-react";
import { motion } from "framer-motion";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function WhyChooseDaxma() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false,
      offset: 100,
    });
  }, []);

  const features = [
    {
      icon: <ShieldCheck className="w-10 h-10" />,
      title: "Premium Quality",
      desc: "Crafted with precision using top-tier fabrics for unmatched comfort and durability.",
    },
    {
      icon: <Sparkles className="w-10 h-10" />,
      title: "Modern Aesthetics",
      desc: "Minimal, clean, and elevated designs made to define your everyday style.",
    },
    {
      icon: <Layers className="w-10 h-10" />,
      title: "Refined Craft",
      desc: "Every stitch reflects luxury craftsmanship designed for true style seekers.",
    },
    {
      icon: <HeartHandshake className="w-10 h-10" />,
      title: "Customer-First Approach",
      desc: "A smooth, trustworthy, and satisfying buying experience—every time.",
    },
  ];

  return (
    <section className="w-full py-20 px-6 md:px-16 bg-white overflow-visible">
      <div className="max-w-6xl mx-auto text-center mb-16">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-3xl md:text-5xl font-bold text-[#1D1F1E]"
        >
          Why Choose <span className="text-[#557170]">DAXMA?</span>
        </motion.h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 max-w-7xl mx-auto">
        {features.map((f, i) => (
          <div
            key={i}
            data-aos="zoom-in"
            data-aos-easing="ease-out-cubic"
            className="bg-[#F7F9FA] rounded-2xl p-8 shadow-sm hover:shadow-[#557170]  transition-all duration-300 flex flex-col items-center text-center"
          >
            <div className="text-[#557170] mb-4">{f.icon}</div>

            <h3 className="text-xl font-semibold mb-2 text-[#1D1F1E]">
              {f.title}
            </h3>

            <p className="text-sm text-gray-600 leading-relaxed">
              {f.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
